import { LogicalFieldMixin } from './mixins.js';

const LogicalTextField = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <input type="text" readonly placeholder='请输入' />
    </div>
  `
};

export default LogicalTextField;
